import EventBus from '@/plugins/vue-event-bus'
import jwtDecode from 'jwt-decode'
import Vue from 'vue'
//import VueCookies from 'vue-cookies'

const defaultUser = () => {
  return {
    _id: null,
    isAuthenticated: false,
    token: '',
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    notifications: [],
    avatarUrl: null,
    isAuthenticated: false
  }
}

const state = () => {
  return defaultUser()
}

const getters = {
  user: (state) => ({
    username: state.username,
    isAuthenticated: state.isAuthenticated
  })
}

const host = location.host.indexOf('feature.watch') > -1 ? 'feature.watch' : location.host

const mutations = {
  SET_TOKEN(state, token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    $cookies.set('__fw_token', token, null, null, host)
  },
  AUTHENTICATE(state, user) {
    Object.assign(state, user, { isAuthenticated: true })
  },
  EXPIRE_USER(state) {
    Object.assign(state, defaultUser())
    delete axios.defaults.headers.common['Authorization']
    $cookies.remove('__fw_token', null, host)
  },
  SET_USER(state, user) {
    Object.assign(state, user, { isAuthenticated: true })
  },
  SIGN_UP_REQUEST(state) {
    state.signUpPending = true
  },
  SIGN_UP_SUCCESS(state, data) {
    Object.assign(state, data, { isAuthenticated: true })
  },
  SIGN_UP_FAILURE(state, error) {},
  SIGN_IN_REQUEST(state) {},
  SIGN_IN_SUCCESS(state, data) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token
    $cookies.set('__fw_token', data.token, null, null, host)
    Object.assign(state, data, { isAuthenticated: true })
  },
  SIGN_IN_FAILURE(state, error) {
    console.log(error)
    console.log('Sign Up Failure.')
  },
  SIGN_OUT_FAILURE(state, error) {
    console.error(error)
  },
  NOTIFICATIONS_SUCCESS(state, data) {
    state.notifications = data
  }
}

const actions = {
  authenticate({ commit, dispatch }) {
    let token = $cookies.get('__fw_token')
    if (token && token !== 'undefined') {
      let user = jwtDecode(token)
      commit('AUTHENTICATE', user)
    } else {
    }
  },
  async getUser({ dispatch, commit }, form) {
    try {
      let { data } = await Vue.axios.get('user')
      commit('SET_USER', data)
      dispatch('getNotifications', null, { root: true })
      return data
    } catch (error) {
      console.log('getUser', error.response)
      commit('EXPIRE_USER')
      throw error.response.data.error
    }
  },
  async updateUser({ commit }, form) {
    try {
      let { data } = await Vue.axios.put('user', form)
      commit('SET_USER', data)
    } catch (error) {
      throw error.response.data.errors
    }
  },

  updateUserReceived({ commit }, event) {
    const { user } = event
    commit('SET_USER', user)
  },

  async updatePassword({ commit }, payload) {
    try {
      let { data } = await Vue.axios.put('user/password', payload)
    } catch (error) {
      throw error.response.data.error
    }
  },
  async register({ commit, dispatch }, payload) {
    console.log(payload)
    try {
      commit('SIGN_UP_REQUEST')
      let { data } = await Vue.axios.post('signup', payload)
      commit('SIGN_UP_SUCCESS', data)
    } catch (error) {
      throw error.response
    }
  },
  async login({ commit, dispatch }, payload) {
    try {
      commit('SIGN_IN_REQUEST')
      let { data } = await Vue.axios.post('login', payload)
      console.log('login', data)
      EventBus.$emit('auth:signin', data.user)
      commit('SIGN_IN_SUCCESS', data.user)
      commit('SET_COMPANY', data.company, { root: true })
      return data
    } catch (error) {
      throw error.response.data
    }
  },

  async postCompanyUser({ commit }, payload) {
    try {
      console.log(payload)
      let { data } = await Vue.axios.post('company/user', payload)
      commit('SIGN_IN_SUCCESS', data)
      return data
    } catch (error) {
      console.log('error posting company user')
    }
  },

  async logout({ commit, dispatch }) {
    window.drift.hide()
    try {
      console.log('logging out')
      EventBus.$emit('auth:signout')
      commit('EXPIRE_USER')
      commit('DELETE_NOTIFICATIONS', null, { root: true })
      dispatch('boards/getBoards', null, { root: true })
    } catch (error) {
      commit('SIGN_OUT_FAILURE', error)
    }
  },
  async verify({ commit, dispatch }, token) {
    try {
      let { data } = await Vue.axios.post('verify-email', token)
      console.log(data)
      commit('SIGN_IN_SUCCESS', data.user)
      return {
        redirectDomain: data.redirectDomain,
        isMember: data.isMember,
        showOnboarding: data.showOnboarding
      }
    } catch (error) {
      console.log(error.response)
    }
  },
  async forgotPassword({ commit, dispatch }, payload) {
    try {
      let { data } = await Vue.axios.post('forgot-password', payload)
      console.log(data)
    } catch (error) {
      console.log(error.response)
    }
  },
  async resetPassword({ commit, dispatch }, payload) {
    try {
      let { data } = await Vue.axios.post('reset-password', payload)
      console.log(data)
      commit('SIGN_IN_SUCCESS', data.user)
      return {
        redirectDomain: data.redirectDomain,
        isMember: data.isMember
      }
    } catch (error) {
      console.log(error.response)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
